module.exports = __webpack_public_path__ + "assets/84bbf6433f833d9f7f36aabacd3acdc8.png";